import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IAuthState {
  isUserAuth: boolean;
  loginWarning: string;
  isAuthModalOpen: boolean;
}

const initialState: IAuthState = {
  isUserAuth: false,
  loginWarning: '',
  isAuthModalOpen: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isUserAuth = action.payload;
    },
    setLoginWarning: (state, action: PayloadAction<string>) => {
      state.loginWarning = action.payload;
    },
    clearLoginWarnings: (state) => {
      state.loginWarning = '';
    },
    setAuthModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isAuthModalOpen = action.payload;
    }
  }
});

export const {
  setIsAuth,
  setLoginWarning,
  clearLoginWarnings,
  setAuthModalOpen
} = authSlice.actions;
export default authSlice;
